import Select from "react-select";
import FieldValidationError from "./FieldValidationError";
import { createSelectStyles, getSelectMenuPortalTarget, selectThemeProps } from "./selectTheme";

const CustomSelect = (props) => {
    const { defaultValue, onChange, options, placeholder, value, isClearable, error, isDisabled, styles, ...rest } = props;

    return (
        <>
            <Select
                value={value}
                defaultValue={defaultValue}
                onChange={onChange}
                options={options}
                placeholder={placeholder}
                {...selectThemeProps}
                isClearable={isClearable}
                isDisabled={isDisabled}
                menuPortalTarget={getSelectMenuPortalTarget()}
                styles={createSelectStyles(styles)}
                {...rest}
            />
            <FieldValidationError error={error} />
        </>
    );
}

export default CustomSelect;
